import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAtom } from 'jotai';
import ViewSwitch, { viewSwitchButtonClass } from '../common/components/ViewSwitch';
import { DiscoveryView, discoveryViewAtom } from './state';

export default function DiscoveryViewSwitch(): React.JSX.Element {
  const { t } = useTranslation(['common', 'search']);
  const [discoveryView, setDiscoveryView] = useAtom(discoveryViewAtom);

  return (
    <Box
      sx={{
        [`& .${viewSwitchButtonClass}`]: {
          width: 108,
        },
      }}
    >
      <ViewSwitch
        value={discoveryView}
        firstViewValue="PRODUCTS"
        secondViewValue="SUPPLIERS"
        firstViewValueLabel={t('common:product_other')}
        secondViewValueLabel={t('search:suppliers')}
        onChange={(value: string) => setDiscoveryView(value as DiscoveryView)}
      />
    </Box>
  );
}
